"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _SwipeNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/SwipeNugget"));

var _DrupalSwipeNugget = _interopRequireDefault(require("./DrupalSwipeNugget.scss"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _index = require("../../../../KESI2/Services/RemoteControlService/index");

var _FeatureManager = _interopRequireDefault(require("../../../../utils/features/FeatureManager"));

var _DrupalNugget = _interopRequireDefault(require("../../../../../targets/cord_sanofi/DrupalNugget.js"));

var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _QuizNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/QuizNugget"));

var _VoteNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/VoteNugget"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

var _Image = _interopRequireDefault(require("../../Image/Image"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../../helpers/CordovaFileHelper"));

var _reactZoomPanPinch = require("react-zoom-pan-pinch");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _FullscreenOverlay = _interopRequireDefault(require("../../FullscreenOverlay/FullscreenOverlay"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'swipeContainer_';

var DrupalSwipeNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalSwipeNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalSwipeNugget);

  function DrupalSwipeNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalSwipeNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkImageWidths", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(nugget) {
        var filePath, imageContainerWidth, el, elWidth;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filePath = _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder();

                if (nugget.swipeImages && nugget.swipeImages.length > 0) {
                  imageContainerWidth = null;
                  el = document.getElementById('innerSwipeGalleryContainer');

                  if (el) {
                    elWidth = el.offsetWidth;
                    console.log('checkImageWidths', elWidth);

                    _this.setState({
                      imageContainerWidth: elWidth
                    });
                  }
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeIndex", function (index) {
      _this.setState({
        nuggetIndex: index
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "imgToFullScreen", function (imgSrc) {
      _this.setState({
        showFullscreenOverlay: true,
        fullScreenImg: imgSrc
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "imgExitFullScreen", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                showFullscreenOverlay: false,
                fullScreenImg: null
              });

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderSwipeContent", function (nugget) {
      var filePath = _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder();

      if (nugget.contents && nugget.contents.length > 0) {
        return nugget.contents.map(function (nuggetToMap, index) {
          // not needed for now but maybe useful in the future
          // const nuggetData = KESI2Helper.getContentById(nuggetToMap.id)
          if (_config["default"].prerenderNextSwipeNugget && (index < _this.state.nuggetIndex - 1 || index > _this.state.nuggetIndex + 1)) {
            // null is not allowed in swipeable views so return an empty div
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: nuggetToMap.id
            });
          } else if (!_config["default"].prerenderNextSwipeNugget && index !== _this.state.nuggetIndex) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: nuggetToMap.id
            });
          }

          return /*#__PURE__*/_react["default"].createElement("div", {
            key: nuggetToMap.id
          }, /*#__PURE__*/_react["default"].createElement(_DrupalNugget["default"], {
            id: nuggetToMap.id,
            path: _this.props.path,
            registerNugget: _this.props.registerNugget,
            markAsRead: _this.props.markAsRead,
            contentPathArray: _this.props.contentPathArray,
            inSwipeContainer: true
          }));
        });
      } else if (nugget.swipeImages && nugget.swipeImages.length > 0) {
        return nugget.swipeImages.map(function (imageObj, index) {
          console.log('swipeImage', imageObj);
          var image = imageObj.img;
          var alt = imageObj.alt;

          if (_config["default"].prerenderNextSwipeNugget && (index < _this.state.nuggetIndex - 1 || index > _this.state.nuggetIndex + 1)) {
            // null is not allowed in swipeable views so return an empty div
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: "swipeimage_".concat(index)
            });
          } else if (!_config["default"].prerenderNextSwipeNugget && index !== _this.state.nuggetIndex) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: "swipeimage_".concat(index)
            });
          }

          return /*#__PURE__*/_react["default"].createElement("div", {
            key: "swipeimage_".concat(index),
            onClick: _config["default"].imgFullScreenOnClick ? function () {
              return _this.imgToFullScreen("".concat(filePath).concat(image));
            } : null
          }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
            alt: "swipe image",
            className: _DrupalSwipeNugget["default"].swipeImage,
            src: _DeviceInfoHelper["default"].isBrowser() ? image : "".concat(filePath).concat(image)
          }), alt ? /*#__PURE__*/_react["default"].createElement("div", {
            className: _DrupalSwipeNugget["default"].subtitle
          }, alt) : null);
        });
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", null, "No Content!");
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "scrollTo", function (element, to, duration) {
      var start = element.scrollLeft;
      var change = to - start;
      var startDate = new Date().getTime(); // t = current time
      // b = start value
      // c = change in value
      // d = duration

      var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };

      var animateScroll = function animateScroll() {
        var currentDate = new Date().getTime();
        var currentTime = currentDate - startDate;
        console.log('scrollTo', start, to, change, startDate);
        element.scrollLeft = (0, _parseInt2["default"])(easeInOutQuad(currentTime, start, change, duration));

        if (currentTime < duration) {
          requestAnimationFrame(animateScroll);
        } else {
          element.scrollLeft = to;
        }
      };

      animateScroll();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "moveToImage", function (index) {
      var isLast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.setState({
        nuggetIndex: index
      });

      if (isLast) {
        if (!_this.props.inSwipeContainer) {
          _this.props.markAsRead(_this.props.id);
        }
      }
    });
    _this.state = _objectSpread({
      nuggetIndex: 0,
      waitingForActivation: false,
      imageContainerWidth: null,
      imageWidths: []
    }, _this.state);
    _this.active = true;

    _this.props.registerNugget(_this.props.id, _SwipeNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalSwipeNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalSwipeNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _SwipeNugget["default"].CLASS, this.getDomId());

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      var nugget = this.state.content[this.props.id];

      if (nugget.contents && nugget.contents.length === 1) {
        this.props.markAsRead(this.props.id);
      }

      this.checkImageWidths(nugget);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalSwipeNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join('!')), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join('!')] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
    /*
    componentWillUpdate (newProps, newState) {
      const nugget = newState.content[this.props.id]
       const active = DataStore.pathExists(`${this.props.id}.${this.props.contentPathArray.join(KESI_PATH_DELIMITER)}`, newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES])
        ? newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(KESI_PATH_DELIMITER)]
        : nugget.active
       if (newState.waitingForActivation && active !== this.active) {
        newState['waitingForActivation'] = false
      }
    }
    */

  }, {
    key: "nextSlide",
    value: function nextSlide(nuggetLength) {
      var newIndex = this.state.nuggetIndex + 1;

      if (newIndex === nuggetLength - 1) {
        if (!this.props.inSwipeContainer) {
          this.props.markAsRead(this.props.id);
        }
      }

      if (newIndex < nuggetLength) {
        this.setState({
          nuggetIndex: newIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /**
       * @type {SwipeNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var contents = nugget.contents && nugget.contents.length > 0 ? nugget.contents : nugget.swipeImages && nugget.swipeImages.length > 0 ? nugget.swipeImages : [];
      var filePath = _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "swipeContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        id: "swipeContainer",
        className: "swipeNugget_".concat(this.props.id, " ").concat(nugget.theme, " ").concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.show_title && (_config["default"].targetTag !== "visitberlin" ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.inGalleryContainer ? 'titleSmall' : 'title')
      }, nugget.title) : /*#__PURE__*/_react["default"].createElement("h1", {
        className: this.props.inGalleryContainer ? 'titleSmall' : 'title'
      }, nugget.title)), /*#__PURE__*/_react["default"].createElement("div", {
        className: nugget.swipeImages && nugget.swipeImages.length > 0 ? 'swipeImageNuggetContainer' : 'swipeNuggetContainer'
      }, !_config["default"].showSwipeNavigationAtTheBottom && !nugget.showExtraGallery && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_DrupalSwipeNugget["default"].navigationContainer, " ").concat(innerClassNames)
      }, this.state.nuggetIndex > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalSwipeNugget["default"].buttonLeft,
        style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
          color: this.props.forcedUIColor
        } : {
          color: '#9b9b9b'
        },
        onClick: function onClick() {
          return _this2.state.nuggetIndex > 0 ? _this2.setState({
            nuggetIndex: _this2.state.nuggetIndex - 1
          }) : function () {};
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        className: _DrupalSwipeNugget["default"].arrowIcon,
        name: "arrow-circle-left"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalSwipeNugget["default"].bulletContainer
      }, contents && contents.length > 0 && contents.map(function (nugget, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          className: _DrupalSwipeNugget["default"].nuggetBullet,
          style: {
            backgroundColor: _this2.state.nuggetIndex === index ? _cssConstants["default"].colors.buttonBackground : '#9B9B9B'
          }
        });
      })), this.state.nuggetIndex < nugget.contents.length - 1 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalSwipeNugget["default"].buttonRight,
        style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
          color: this.props.forcedUIColor
        } : {
          color: '#9b9b9b'
        },
        onClick: function onClick() {
          return _this2.nextSlide(contents.length);
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        className: _DrupalSwipeNugget["default"].arrowIcon,
        name: "arrow-circle-right"
      }))), /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
        disabled: _DeviceInfoHelper["default"].isBrowser(),
        index: this.state.nuggetIndex,
        onChangeIndex: function onChangeIndex(index, lastIndex) {
          _this2.onChangeIndex(index);
        },
        className: 'swipeContent'
      }, this.renderSwipeContent(nugget)), _config["default"].showSwipeNavigationAtTheBottom && !nugget.showExtraGallery && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_DrupalSwipeNugget["default"].navigationContainer, " ").concat(innerClassNames)
      }, this.state.nuggetIndex > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalSwipeNugget["default"].buttonLeft,
        style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
          color: this.props.forcedUIColor
        } : {
          color: '#9b9b9b'
        },
        onClick: function onClick() {
          return _this2.state.nuggetIndex > 0 ? _this2.setState({
            nuggetIndex: _this2.state.nuggetIndex - 1
          }) : function () {};
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        className: _DrupalSwipeNugget["default"].arrowIcon,
        name: "arrow-circle-left"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalSwipeNugget["default"].bulletContainer
      }, contents && contents.length > 0 && contents.map(function (nugget, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          className: _DrupalSwipeNugget["default"].nuggetBullet,
          style: {
            backgroundColor: _this2.state.nuggetIndex === index ? _cssConstants["default"].colors.buttonBackground : '#9B9B9B'
          }
        });
      })), this.state.nuggetIndex < contents.length - 1 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalSwipeNugget["default"].buttonRight,
        style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
          color: this.props.forcedUIColor
        } : {
          color: '#9b9b9b'
        },
        onClick: function onClick() {
          return _this2.nextSlide(contents.length);
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        className: _DrupalSwipeNugget["default"].arrowIcon,
        name: "arrow-circle-right"
      }))), _config["default"].showSwipeImagePreview && nugget.showExtraGallery && nugget.swipeImages && nugget.swipeImages.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_DrupalSwipeNugget["default"].navigationContainer, " ").concat(innerClassNames)
      }, this.state.nuggetIndex > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalSwipeNugget["default"].buttonLeftTop,
        style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
          color: this.props.forcedUIColor
        } : {
          color: '#9b9b9b'
        },
        onClick: this.state.nuggetIndex > 0 ? function () {
          _this2.moveToImage(_this2.state.nuggetIndex - 1);
        } : function () {}
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        className: _DrupalSwipeNugget["default"].arrowIcon,
        name: "arrow-circle-left"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        id: 'swipeGalleryContainer',
        className: _DrupalSwipeNugget["default"].galleryContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: 'innerSwipeGalleryContainer',
        className: _DrupalSwipeNugget["default"].innerGalleryContainer
      }, contents && contents.length > 0 && contents.map(function (imageObj, index) {
        var image = imageObj.img;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          className: "".concat(_DrupalSwipeNugget["default"].galleryImage, " ").concat(_this2.state.nuggetIndex === index ? _DrupalSwipeNugget["default"].activeImage : ''),
          onClick: function onClick() {
            return _this2.moveToImage(index);
          },
          style: _this2.state.imageContainerWidth ? {
            width: "".concat(_this2.state.imageContainerWidth / 4, "px"),
            height: "".concat(_this2.state.imageContainerWidth / 4, "px")
          } : {}
        }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          alt: "swipe gallery image",
          id: "swipeGalleryImage_".concat(index),
          style: _this2.state.imageContainerWidth ? {
            height: "".concat(_this2.state.imageContainerWidth / 4, "px")
          } : {},
          src: _DeviceInfoHelper["default"].isBrowser() ? image : "".concat(filePath).concat(image)
        }));
      }))), this.state.nuggetIndex < contents.length - 1 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalSwipeNugget["default"].buttonRightTop,
        style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
          color: this.props.forcedUIColor
        } : {
          color: '#9b9b9b'
        },
        onClick: function onClick() {
          _this2.moveToImage(_this2.state.nuggetIndex + 1, _this2.state.nuggetIndex + 2 === contents.length);
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        className: _DrupalSwipeNugget["default"].arrowIcon,
        name: "arrow-circle-right"
      })))), _config["default"].addZoomClickToImages && /*#__PURE__*/_react["default"].createElement(_FullscreenOverlay["default"], {
        open: this.state.showFullscreenOverlay
      }, /*#__PURE__*/_react["default"].createElement(_reactZoomPanPinch.TransformWrapper, {
        panningEnabled: !this.state.scrollingEnabled,
        onPinching: function onPinching(values) {
          return _this2.setScale(values);
        },
        enableZoomedOutPanning: true,
        minScale: 1,
        defaultScale: 1
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalSwipeNugget["default"].iconContainer
      }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        color: "primary",
        className: _DrupalSwipeNugget["default"].icon,
        onClick: this.imgExitFullScreen
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          transform: "rotate(".concat(this.state.imgRotation, "deg)")
        },
        className: _DrupalSwipeNugget["default"].portraitOverlayImgContainer
      }, /*#__PURE__*/_react["default"].createElement(_reactZoomPanPinch.TransformComponent, null, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "fullscreen overlay image",
        className: _DrupalSwipeNugget["default"].fullScreenOverlayImg,
        src: this.state.fullScreenImg ? this.state.fullScreenImg : null
      })))))));
    }
  }]);
  return DrupalSwipeNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalSwipeNugget;
DrupalSwipeNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  forcedUIColor: _propTypes["default"].string,
  renderIcon: _propTypes["default"].func.isRequired,
  isInTutorial: _propTypes["default"].bool
};
DrupalSwipeNugget.defaultProps = {
  id: null
};